import React, { useState, useEffect } from 'react'
import './ProductStyle.css'
import Postcard from '../../Components/Card/Postcard'
import axios from 'axios'

export const News = () => {
  const [posts, setPosts] = useState([])
  const BASE_URL = 'https://www.googleapis.com/blogger/v3/blogs/'

  const getAllPosts = () => {
    axios
      .get(
        BASE_URL +
          process.env.REACT_APP_BLOG_ID +
          '/posts?key=' +
          process.env.REACT_APP_BLOG_API_KEY +
          '&maxResults=2'
      )
      .then((response) => {
        setPosts(response.data.items)
      })
      .catch((err) => {})
  }

  useEffect(() => {
    getAllPosts()
  }, [])

  return (
    <div style={{ backgroundColor: 'white' }}>
      <h1 className=" text-center text-dark p-3">Latest Updates</h1>

      {posts.map((post) => {
        return (
          <div key={post.id}>
            <Postcard
              key={post.id}
              postId={post.id}
              title={post.title}
              content={post.content}
              imageUrl={
                post.content &&
                post.content.match(/src=(.+?[.jpg|.gif|.png]")/)[1]
              }
              date={post.updated}
              author={post.author.displayName}
            />
          </div>
        )
      })}
    </div>
  )
}
